import { Segment, Track } from './StepProgress.styles';
import type { StepProgressProps } from './StepProgress.types';

export function StepProgress({
  totalSteps,
  currentStep,
  label = 'Progress',
  valueText,
}: StepProgressProps) {
  return (
    <Track
      role="progressbar"
      aria-label={label}
      aria-valuemin={1}
      aria-valuemax={totalSteps}
      aria-valuenow={currentStep}
      aria-valuetext={valueText ?? `Step ${currentStep} of ${totalSteps}`}
    >
      {Array.from({ length: totalSteps }, (_, index) => (
        <Segment key={index} data-active={index < currentStep ? 'true' : 'false'} />
      ))}
    </Track>
  );
}
